import React, { FC } from 'react';
import { IconProps } from './type';

export const IconArrowRightSmall: FC<React.PropsWithChildren<IconProps>> = ({ className = '', width = 5, height = 9 }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 8L4 4.37931L1 1" stroke="currentColor" />
  </svg>
);
